<div class="modal">
  <h2 class="h2 mb-0 align-center align-left--ps">{{data.title ? data.title : 'Are you sure?'}}</h2>
  <div class="ml-0 mr-0 pl-0 pr-0">
    <p class=" align-center align-left--ps"
       [innerHTML]="data.message | safeHtml"></p>
  </div>
  <div class="d-flex--ps flexJustify-between">
    <button class="btn btn--red d-block w-100 w-auto--ps mb-0100 mb-0--ps"
            type="button"
            (click)="choiceClicked(true)"
            cdkFocusInitial>{{confirmButtonText}}</button>
    <button class="btn btn--whiteRed d-block w-100 w-auto--ps"
            type="button"
            (click)="choiceClicked(false)">{{cancelButtonText}}</button>
  </div>
</div>
